"use client";
import "../../src/common/grid.css";
import "../../src/common/not-found.css";
import { Box, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Image from "next/image";
import img from "../../src/assets/images/error-image.webp";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const handleKeyContactClick = () => {
    router.push("/contact");
  };
  const handleKeyChoiceClick = () => {
    router.push("/");
  };
  return (
    <>
      <div className="homepageBannerSection">
        <div className="container">
          <div className="homepageBannerContent">
            <h1 className="homepageBannerTitle">
              {t("Page Not Found")}
            </h1>
            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography
                onClick={handleKeyChoiceClick}
                className="backText"
              >
                {t("Key Choice Lending")}
              </Typography>
              <ArrowForwardIosIcon sx={{ color: "#ffffff", fontSize: 13 }} />
              <Typography className="linkText">
                <span>{t("Page Not Found")}</span>
              </Typography>
            </Box>
          </div>
        </div>
      </div>
      <div className="errorsection">
        <div className="container">
          <div className="errorpagewrapper">
            <div className="imagewrapper">
               <Image src={img} alt={t("Error image")} className="image"/>
            </div>
            <h1 className="title">{t("Oops!")}</h1>
            <h2 className="subtitle">{t("Page not found")}</h2>
            <p className="description">
              {t("The page you're looking for doesn't exist or has been moved. Don't worry, you can find plenty of other things on our homepage.")}
            </p>
            <div className="buttoncontainer">
              <a
                className="button homebtn"
                onClick={handleKeyChoiceClick}
              >
                <span className="home-icon">🏠</span>
                {t("Back to Home")}
              </a>
              <a
                className="button homebtn"
                onClick={handleKeyContactClick}
              >
                {t("Contact Support")}
                <span className="arrow-icon">➡️</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NotFoundPage;
